import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { faqs } from '../data/landing';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-20 bg-brand-light-sage" data-id="element-11" data-mp="1nu9n4u4pvu5y">
      <div className="max-w-3xl mx-auto px-6" data-id="element-12" data-mp="1nwvvux3cgfpr">
        <FadeIn data-id="element-13" data-mp="2bk3y165h78nk">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-forest text-center mb-12" data-id="element-14" data-mp="2blnh14iinxt1">
            Preguntas frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-15" data-mp="21v2kdmmel3cr">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-16" data-mp="26tnlrpde5t2s" data-mpi={index}>
              <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-17" data-mp="26scgfl4asd9k">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-18" data-mp="2uh57p49z5wxu">
                  <span className="font-serif font-bold text-lg text-brand-charcoal pr-4" data-id="element-19" data-mp="1rpqxdernyhge">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-forest transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-20" data-mp="20ouj6qi7tayl" />
                </button>

                <AnimatePresence data-id="element-21" data-mp="2afgqzyjowx6q">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-22" data-mp="2oe6mj9qv2osz">
                      <div className="px-6 pb-5 text-brand-gray leading-relaxed" data-id="element-23" data-mp="2z1rm31ornjgj">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}